import { render, staticRenderFns } from "./createResponsibleDialog.vue?vue&type=template&id=0be27a2f"
import script from "./createResponsibleDialog.vue?vue&type=script&lang=ts"
export * from "./createResponsibleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports